import React from 'react';

const Content = () => {
  return (
    <div className="modal-content">
      <div className="modal-title">
        <h2>How to use it</h2>
      </div>
      <div className="modal-update">
        <p>Updated October 2026</p>
      </div>
      <div className="has-padding">
        <h4>Using the interactive map:</h4>
        <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
          <li>
            1. Explore the South East Water projects through our interactive map
            and find out what is happening near you.
          </li>
          <li>
            2. Type your address into the search field in the top right hand
            corner to discover water projects in your area.
          </li>
          <li>3. Use the left-hand topics menu to get more information.</li>
          <li>
            4. For interpreter translation service, hover over the icon on the
            bottom left hand side for more options.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Content;
